// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15xbU","question":"styles_question__3asSy","inputVisibleButton":"styles_inputVisibleButton__2KvDp","note":"styles_note__IiGx6"};